import { render, staticRenderFns } from "./StatelessTags.vue?vue&type=template&id=57b65596&"
import script from "./StatelessTags.vue?vue&type=script&lang=js&"
export * from "./StatelessTags.vue?vue&type=script&lang=js&"
import style0 from "./StatelessTags.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports